import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { ErrorModule } from '../errors/error.module';
import { InputComponent } from './components/input.component';

@NgModule({
    imports: [
        FormsModule,
        CommonModule,
        ReactiveFormsModule,

        ErrorModule,
    ],
    declarations: [
        InputComponent,
    ],
    exports: [
        InputComponent,
    ],
})

export class InputModule {}
